import { render, staticRenderFns } from "./PreviewArea.vue?vue&type=template&id=b2b53904"
import script from "./PreviewArea.vue?vue&type=script&lang=js"
export * from "./PreviewArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports